import React from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faUnlock } from "@fortawesome/free-solid-svg-icons";
import { format } from "date-fns";

interface DeletedItemBannerProps {
  title?: string;
  message?: string;
  deletedAt?: Date | string;
  onRestore: () => void;
  restoreButtonText?: string;
  badgeText?: string;
}

const DeletedItemBanner: React.FC<DeletedItemBannerProps> = ({
  title = "Este item foi excluído e não tem mais acesso ao sistema",
  message = "Todas as informações são apresentadas apenas para referência. Para editar o item, restaure o acesso primeiro.",
  deletedAt,
  onRestore,
  restoreButtonText = "Restaurar Acesso",
  badgeText = "Item Inativo",
}) => {
  return (
    <div className="mb-4">
      <div className="card border-0 shadow-sm">
        <div
          className="position-relative p-4 rounded"
          style={{
            background:
              "linear-gradient(45deg, rgba(220,53,69,0.03) 0%, rgba(220,53,69,0.08) 100%)",
          }}
        >
          <div className="d-flex align-items-center">
            <div
              className="rounded-circle bg-danger bg-opacity-10 p-3 me-3 d-flex align-items-center justify-content-center"
              style={{ width: "60px", height: "60px" }}
            >
              <FontAwesomeIcon icon={faTrash} className="text-danger fs-4" />
            </div>
            <div className="flex-grow-1">
              <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
                <span className="badge bg-danger bg-opacity-75 rounded-pill px-3 py-2 fw-normal">
                  {badgeText}
                </span>
              </div>
              <h5 className="mb-1">{title}</h5>
              <p className="mb-0">{message}</p>
              {deletedAt && (
                <small className="text-muted">
                  Excluído em: {format(new Date(deletedAt), 'dd/MM/yyyy HH:mm')}
                </small>
              )}
            </div>
            <Button
              variant="outline-danger"
              onClick={onRestore}
              className="ms-3 py-2 px-3 rounded-pill d-flex align-items-center gap-2"
            >
              <FontAwesomeIcon icon={faUnlock} />
              <span className="d-none d-sm-inline">{restoreButtonText}</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeletedItemBanner;
